export const PERFORMANCE_TAB_NAMES = {
  summary: {
    key: 'summary',
    label: 'summary',
  },
  history: {
    key: 'history',
    label: 'history',
  },
  reviews: {
    key: 'reviews',
    label: 'reviews',
  },
  points: {
    key: 'points',
    label: 'points',
  },
};
